import React from 'react';
import {Col, Row} from "reactstrap";
import TileComingSoon from "../../../../../components/customBreachBits/metrics/TileComingSoon";

const AdminInsiderPage = (props) => {
    return(
        <div className="app-wrapper h-100">

            <Row>
                <Col>
                    <TileComingSoon subtitle={"New Threats Detected"}/>
                </Col>
                <Col>
                    <TileComingSoon subtitle={"Insider Scans"}/>
                </Col>
                <Col >
                    <TileComingSoon subtitle={"Recent Insider Breaches"}/>
                </Col>
                <Col>
                    <TileComingSoon subtitle={"Attack on Demands Ordered"}/>
                </Col>
                <Col>
                    <TileComingSoon subtitle={"Attack on Demands Launched"}/>
                </Col>

            </Row>
            <Row>
                <Col>
                    <TileComingSoon />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TileComingSoon />
                </Col>
            </Row>
        </div>
    )
}

export default AdminInsiderPage;